/**
 *
 * LeadersImport
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Icon } from "@ant-design/compatible"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ImportScreen from "components/ImportScreen"
import EmptyButton from "components/EmptyButton"
import { makeSelectIsDownloading, makeSelectIsUploading } from "./selectors"
import { getTemplate, uploadTemplate } from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import importSvg from "../../images/emptyLeadersImport.svg"
import { LeftOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
export class LeadersImport extends React.Component {
  state = {}

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])

    this.props.uploadTemplate(fd)
    this.fileInput.value = ""
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Activación de líderes</title>
          <meta name="description" content="Description of Import" />
        </Helmet>
        <div style={{ padding: "32px 64px" }}>
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            to="/control-panel#user-management">
            <LeftOutlined /> Gestión de usuarios
          </Link>
        </div>
        <ImportScreen
          image={importSvg}
          title="Activación de líderes"
          secondPoint='Llena la columna "Usuario líder" según las instrucciones del Excel.'
          thirdPoint="Importa el Excel con la información respectiva."
          description={`
            Activa a los líderes de tu plataforma como <span>usuarios</span> para que estos puedan ingresar a la<br /> 
            plataforma y <span>visualizar sus resultados</span> conforme se vayan recolectando.
          `}>
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={this.props.isDownloading}
            onClick={() => this.props.getTemplate(true)}
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={this.props.isUploading}
            label="Activación de líderes"
            style={{ marginLeft: "2rem" }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </ImportScreen>
      </React.Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplate: (params) => dispatch(getTemplate(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "leadersImport", reducer })
const withSaga = injectSaga({ key: "leadersImport", saga })

export default compose(withReducer, withSaga, withConnect)(LeadersImport)
